const GuruMapel ={
    idGuru:null,
    namaGuru:null,
    usernameGuru:null,
    idMapel:null,
    namaMapel:null,
    idKelas:null,
    namaKelas:null,
    idSekolah:null,
    idDetailGuruMapel:null
}

export default GuruMapel;